// Though Stats is a server component and this could be in the same
// file, it's separate to avoid circular dependency between PDP and course page.
export const statsFragment = `
  fragment statsFragment on StatsModuleRecord {
    equalizeWidths
    figureColor
    moduleFormat { ...moduleFormatFragment }
    stats {
      caption
      figure
    }
  }
`;
